import { Mail, ArrowLeft } from 'lucide-react'
import { Link } from '@/components/common/CustomLink'
import { useTranslation } from 'react-i18next'

import { Button } from '@/components/ui/button'
import { AuthenticationLayout } from '@/components/layout/AuthenticationLayout'
import { useNavigate } from '@/hooks/useCustomNavigate'

interface ForgotPasswordSuccessProps {
  email: string
  onResend: () => void
  resetToken?: string
}

export function ForgotPasswordSuccess({
  email,
  onResend,
  resetToken,
}: ForgotPasswordSuccessProps) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isDevelopment = true

  const handleDevResetPassword = () => {
    if (resetToken) {
      navigate(`/reset-password?token=${resetToken}`)
    }
  }

  return (
    <AuthenticationLayout
      icon={<Mail className='w-6 h-6 text-dark-600' />}
      title={t('auth.checkYourEmail')}
      description={
        <>
          {t('auth.passwordResetLinkSent')}{' '}
          <span className='font-semibold text-dark-900'>{email}</span>
        </>
      }
    >
      {isDevelopment && resetToken && (
        <div className='pb-4 border-b border-gray-200'>
          <Button
            onClick={handleDevResetPassword}
            className='w-full bg-amber-500 hover:bg-amber-600 text-white'
            type='button'
          >
            🔧 Dev: Go to Reset Password
          </Button>
          <p className='text-xs text-center text-gray-500 mt-2'>
            Development only - bypasses email
          </p>
        </div>
      )}

      <div className='text-center text-sm text-gray-600'>
        {t('auth.didntReceiveEmail')}{' '}
        <Button variant={'link'} onClick={onResend}>
          {t('auth.resend')}
        </Button>
      </div>

      <div className='flex items-center justify-center pt-2'>
        <Link
          to='/login'
          className='flex items-center gap-2 text-sm text-gray-700 hover:text-gray-900 font-bold'
        >
          <ArrowLeft className='w-4 h-4' />
          {t('auth.backToLogin')}
        </Link>
      </div>
    </AuthenticationLayout>
  )
}
